import styled from "styled-components";

export const ContentCalendarEvent = styled.div` 
    grid-column: 1;
    grid-row: span 2;
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.secondaryGrayLightNine};
    padding: 19px 24px;
    width: 100%;
    .calendar-event_title {
        font-size: 24px;
        font-weight: 700;
        a {
            color: ${({ theme }) => theme.secondaryDarkOne};
            text-decoration: none;
        }
        .MuiSvgIcon-root {
            font-size: 16px;
            margin-left: 15px;
        }
    }

`;